<template>
  <div class="token-page">
    <div class="token-shell">
      <v-card class="hero-card" flat>
        <div class="hero-top">
          <div>
            <!--<div class="eyebrow">Device Control</div></p>-->
            <div class="title-wrap">
              <h1 class="page-title">Token Manager</h1>
              <span class="title-accent"></span>
            </div>
            <!--<p class="page-subtitle">
              Manage topics, monitor payloads, and send commands with a cleaner workflow.
            </p>-->
          </div>

          <v-btn class="add-btn" depressed @click="resetAddDialog">
            <v-icon left small>mdi-plus</v-icon>
            Add Token
          </v-btn>
        </div>
      </v-card>

      <div class="stats-grid">
        <v-card class="stat-card stat-card--featured" flat>
          <div class="stat-label">Total Tokens</div>
          <div class="stat-value">{{ channellist.length }}</div>
          <!--<div class="stat-desc">Configured topics in your account</div>-->
        </v-card>

        <v-card class="stat-card" flat>
          <div class="stat-label">Logging Enabled</div>
          <div class="stat-value">{{ enabledLogCount }}</div>
          <!--<div class="stat-desc">Tokens with active log tracking</div>-->
        </v-card>

        <!--<v-card class="stat-card" flat>
          <div class="stat-label">Matched Devices</div>
          <div class="stat-value">{{ matchedDevicesCount }}</div>
          <div class="stat-desc">Topics currently linked to a device payload</div>
        </v-card>-->
      </div>

      <v-card class="content-card" flat>
        <div class="toolbar-row">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Search token or payload"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>

        <div class="table-wrap">
          <v-simple-table>
            <thead>
              <tr>
                <th>Token</th>
                <th>Payload</th>
                <th>Log</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredChannels" :key="item.i || item.channel" class="table-row">
                <td class="token-cell">{{ item.channel }}</td>
                <td>
                  <span class="payload-chip">{{ getPayload(item.channel) }}</span>
                </td>
                <td>
                  <span :class="['log-chip', item.EnableLog ? 'log-chip--enabled' : 'log-chip--disabled']">
                    {{ item.EnableLog ? 'Enabled' : 'Disabled' }}
                  </span>
                </td>
                <td>
                  <div class="action-btns">
                    <v-btn small depressed class="btn-edit" @click="openEditDialog(item)">
                      <v-icon left x-small>mdi-pencil</v-icon>
                      Edit
                    </v-btn>
                    <v-btn
                      small
                      depressed
                      :class="item.EnableLog ? 'btn-log-off' : 'btn-log-on'"
                      @click="edit_log(item)"
                    >
                      <v-icon left x-small>{{ item.EnableLog ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline' }}</v-icon>
                      {{ item.EnableLog ? 'Disable Log' : 'Enable Log' }}
                    </v-btn>
                    <v-btn small depressed class="btn-delete" @click="remove(item)">
                      <v-icon left x-small>mdi-delete-outline</v-icon>
                      Delete
                    </v-btn>
                  </div>
                </td>
              </tr>

              <tr v-if="!filteredChannels.length">
                <td colspan="4">
                  <div class="empty-state">
                    <v-icon large color="#8E7AC5">mdi-database-search-outline</v-icon>
                    <div class="empty-title">No tokens found</div>
                    <div class="empty-subtitle">Try a different keyword or add a new token.</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card>
    </div>

    <v-dialog v-model="add" max-width="560px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">Add Token</v-card-title>
        <v-card-text class="dialog-body">
          <v-text-field
            v-model="addtoken"
            label="Topic"
            outlined
            dense
            color="#7B4DFF"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="add = false">Cancel</v-btn>
          <v-btn class="dialog-primary" depressed @click="addchanel">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="edit" max-width="560px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">Edit Payload</v-card-title>
        <v-card-text class="dialog-body">
          <v-text-field
            v-model="editpayload"
            label="Payload"
            outlined
            dense
            color="#7B4DFF"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="edit = false">Cancel</v-btn>
          <v-btn class="dialog-primary" depressed @click="edit_payload">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      channellist: [],
      add: false,
      addtoken: "",
      edit: false,
      editpayload: "",
      edittoken: "",
      search: "",
    };
  },
  computed: {
    filteredChannels() {
      const keyword = this.search.trim().toLowerCase();
      if (!keyword) return this.channellist;

      return this.channellist.filter((item) => {
        const payload = String(this.getPayload(item.channel)).toLowerCase();
        return item.channel.toLowerCase().includes(keyword) || payload.includes(keyword);
      });
    },
    enabledLogCount() {
      return this.channellist.filter((item) => item.EnableLog).length;
    },
    matchedDevicesCount() {
      return this.channellist.filter((item) => !!this.findDevice(item.channel)).length;
    },
  },
  methods: {
    ...mapActions(["doPublish", "doConnection", "fetchChannels"]),
    async channelupdate(reconnect = true) {
      await this.fetchChannels(this.$store.state.user.token);
      this.channellist = this.$store.state.channel;

      if (reconnect) {
        await this.doConnection();
      }
    },
    async remove(item) {
      await axios.get(
        `${this.$store.state.serverUrl}channelremove/${encodeURIComponent(item.channel)}`
      );
      await this.channelupdate();
    },
    async addchanel() {
      const topic = this.addtoken.trim();
      if (!topic) return;

      await axios.get(
        `${this.$store.state.serverUrl}channeladd/${encodeURIComponent(this.$store.state.user.token)}/${encodeURIComponent(topic)}`
      );
      await this.channelupdate();
      this.add = false;
    },
    async edit_log(item) {
      await axios.get(`${this.$store.state.serverUrl}editlog/${encodeURIComponent(item.channel)}`);
      await this.channelupdate(false);
    },
    async edit_payload() {
      await this.doPublish({ topic: this.edittoken, payload: this.editpayload });
      this.edit = false;
    },
    resetAddDialog() {
      this.add = true;
      this.addtoken = "";
    },
    findDevice(channel) {
      return this.$store.state.devices.find((device) => device.topic === channel);
    },
    getPayload(channel) {
      const device = this.findDevice(channel);
      return device ? device.payload : "-";
    },
    openEditDialog(item) {
      const device = this.findDevice(item.channel);
      this.editpayload = device ? device.payload : "";
      this.edittoken = item.channel;
      this.edit = true;
    },
  },
  mounted() {
    this.channelupdate(false);
  },
};
</script>

<style scoped>
.token-page {
  min-height: 100%;
  padding: 28px;
  background:
    radial-gradient(circle at top right, rgba(123, 77, 255, 0.14), transparent 28%),
    linear-gradient(180deg, #f8f5ff 0%, #f4f1fb 100%);
}

.token-shell {
  max-width: 1280px;
  margin: 0 auto;
}

.hero-card,
.content-card,
.stat-card,
.dialog-card {
  border-radius: 24px;
}

.hero-card {
  padding: 26px 28px 22px;
  margin-bottom: 18px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(122, 95, 170, 0.1);
  box-shadow: 0 16px 40px rgba(73, 43, 122, 0.08);
}

.hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.eyebrow {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #7d6aab;
  margin-bottom: 6px;
}

.title-wrap {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
}

.page-title {
  margin: 0;
  font-size: 3rem;
  line-height: 1.02;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #24113d;
}

.title-accent {
  width: 58px;
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, #7b4dff 0%, #c7b5ff 100%);
  box-shadow: 0 8px 18px rgba(123, 77, 255, 0.22);
  transform: translateY(4px);
}

.page-subtitle {
  margin: 0;
  max-width: 760px;
  font-size: 1rem;
  line-height: 1.7;
  color: #786b96;
}

.add-btn,
.dialog-primary {
  border-radius: 16px;
  height: 44px !important;
  padding: 0 18px !important;
  color: #fff !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  background: linear-gradient(135deg, #7b4dff 0%, #6a37d4 100%);
  box-shadow: 0 12px 24px rgba(109, 63, 212, 0.22);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.stat-card {
  padding: 22px 24px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(123, 77, 255, 0.08);
  box-shadow: 0 12px 28px rgba(70, 40, 120, 0.06);
}

.stat-card--featured {
  background: linear-gradient(135deg, #6f45e9 0%, #4f2aa7 100%);
}

.stat-label {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.82rem;
  font-weight: 700;
  color: #8577a2;
}

.stat-card--featured .stat-label,
.stat-card--featured .stat-value,
.stat-card--featured .stat-desc {
  color: #fff;
}

.stat-value {
  margin-top: 8px;
  font-size: 3rem;
  line-height: 1;
  font-weight: 800;
  color: #251340;
}

.stat-desc {
  margin-top: 10px;
  color: #877a9e;
  font-size: 0.95rem;
}

.content-card {
  padding: 18px;
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(123, 77, 255, 0.08);
  box-shadow: 0 16px 40px rgba(73, 43, 122, 0.08);
}

.toolbar-row {
  margin-bottom: 12px;
}

.search-field {
  max-width: 420px;
}

.search-field ::v-deep .v-input__slot {
  border-radius: 14px !important;
  box-shadow: none !important;
  border: 1px solid rgba(123, 77, 255, 0.12);
  background: rgba(250, 248, 255, 0.95) !important;
}

.table-wrap {
  overflow-x: auto;
}

.table-wrap ::v-deep table {
  border-collapse: separate;
  border-spacing: 0;
}

.table-wrap ::v-deep thead th {
  font-size: 0.88rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6f5f97;
  background: transparent;
  border-bottom: 1px solid rgba(123, 77, 255, 0.12);
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-wrap ::v-deep tbody td {
  border-bottom: 1px solid rgba(123, 77, 255, 0.08);
  padding-top: 16px;
  padding-bottom: 16px;
  vertical-align: middle;
}

.token-cell {
  font-weight: 700;
  color: #2d1d4e;
}

.payload-chip {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 14px;
  background: #f2ecff;
  color: #6448a4;
  font-weight: 700;
}

.log-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  min-height: 32px;
  padding: 4px 12px;
  border-radius: 10px;
  font-size: 0.86rem;
  font-weight: 700;
}

.log-chip--enabled {
  background: #dff1e2;
  color: #317245;
}

.log-chip--disabled {
  background: #f6dede;
  color: #c04a4a;
}

.action-btns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.action-btns .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.btn-edit {
  background: #ede4ff !important;
  color: #6a3fe6 !important;
}

.btn-log-on {
  background: #dff1e2 !important;
  color: #2f7a4c !important;
}

.btn-log-off {
  background: #f6e5c9 !important;
  color: #a86a18 !important;
}

.btn-delete {
  background: #f7e1e1 !important;
  color: #cf4a4a !important;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 36px 16px;
  text-align: center;
}

.empty-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2d1d4e;
}

.empty-subtitle {
  color: #7a6e95;
}

.dialog-card {
  overflow: hidden;
}

.dialog-title {
  padding: 18px 22px;
  color: #fff;
  font-size: 1.08rem;
  font-weight: 700;
  background: linear-gradient(135deg, #6f45e9 0%, #4f2aa7 100%);
}

.dialog-body {
  padding: 24px 24px 8px !important;
}

.dialog-actions {
  padding: 10px 20px 20px;
}

@media (max-width: 960px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .hero-top {
    flex-direction: column;
  }

  .page-title {
    font-size: 2.45rem;
  }
}

@media (max-width: 600px) {
  .token-page {
    padding: 16px;
  }

  .hero-card,
  .content-card,
  .stat-card {
    border-radius: 20px;
  }

  .page-title {
    font-size: 2rem;
  }

  .title-wrap {
    gap: 10px;
  }

  .title-accent {
    width: 42px;
    height: 8px;
  }

  .search-field {
    max-width: 100%;
  }
}
</style>
